import Vue from 'vue';
import Component from 'vue-class-component';
import { helpers } from '@/helpers';

@Component
export class ResolveCurrencySymbolMixing extends Vue {

    ['$resolveCurrencySymbol'](currencyCode: string) {
        return helpers.resolveCurrencySymbol(currencyCode);
    }

    ['$formatDate'](datetime: string) {
        return helpers.formatDate(datetime);
    }
}
